import React, { createContext,useState } from "react";
const AuthContext = createContext();
export default AuthContext;

export  const AuthContextProvider = (props) => {
    const tidcon = "";    
    const [gnuserid,setgnuserid] = useState(0);
    const [gcusername,setgcusername] = useState('');
    const [token,settoken] = useState('');
    const [isLoggedIn,setisLoggedIn] = useState(false);
    const [gcsecurity,setgcsecurity] = useState([]);
    const [gclang,setgclang] = useState('th');
    

    return(

        <AuthContext.Provider value = {{isLoggedIn,setisLoggedIn,token,settoken,gcusername,setgcusername,gnuserid,setgnuserid,tidcon,gcsecurity,setgcsecurity,gclang,setgclang}}>
            {props.children}
        </AuthContext.Provider>
    )

}